export const RICH_TEXT_EDITOR_TOOLBAR_SETTINGS = {
  items: [
    "Undo",
    "Redo",
    "|",
    "FontName",
    "FontSize",
    "|",
    "Bold",
    "Italic",
    "Underline",
    "CreateLink",
    "FontColor",
    "BackgroundColor",
  ],
};
